module.exports = __webpack_public_path__ + "static/media/team-member-1.7f7850fc.jpeg";